import camelCase from 'lodash/camelCase';
import { QUESTIONS_FOR_TAX } from '../../models/survey';
import { getQuestionsCollection } from '../../selectors/survey/pureSelectors';
import { CheckoutState } from '../../state';

export const hasTaxQuestions = (state: CheckoutState) => {
    const allSurveyQuestionNames = Object.keys(getQuestionsCollection(state));
    const uniqueQuestionsForTaxNames = new Set(
        Object.values(QUESTIONS_FOR_TAX).map(
            (name) => `N-${camelCase(name.replace(/^N-/, ''))}`,
        ),
    );

    return allSurveyQuestionNames.some((name) =>
        uniqueQuestionsForTaxNames.has(name),
    );
};
